// Components
import React, { useCallback, useMemo, useState } from 'react';

import Picture from '@/common/components/atoms/Picture/Picture';
// Libs
// Constants
import { NULL_VALUE } from '@/common/constants';

import {
  UserImageDefaultProps,
  UserImagePropTypes,
} from './UserImage.proptypes';

const UserImage = ({
  avatar,
  className,
  color,
  firstName,
  identifier,
  lastName,
}) => {
  const [imageIs404, setImageIs404] = useState(false);

  /**
   * Return placeholder if avatar is null
   * @type {string}
   */
  const getPlaceholder = useMemo(() => {
    if (
      !firstName ||
      firstName === '' ||
      firstName === NULL_VALUE ||
      !lastName ||
      lastName === '' ||
      lastName === NULL_VALUE
    ) {
      if (identifier) {
        return identifier.substring(0, 2).toUpperCase();
      }

      return null;
    }

    return `${firstName.charAt(0).toUpperCase()}${lastName
      .charAt(0)
      .toUpperCase()}`;
  }, [firstName, identifier, lastName]);

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['user-image', className].filter((val) => val).join(' '),
    [className],
  );

  /**
   * On avatar return error
   * @type {(function(): void)|*}
   */
  const onAvatarError = useCallback(() => {
    setImageIs404(true);
  }, []);

  return (
    <div className={classNames} data-qa-id="user-image">
      {avatar && !imageIs404 ? (
        <Picture
          alt={`${firstName} ${lastName}`}
          className="user-image__image"
          src={avatar}
          onError={onAvatarError}
          type="static"
        />
      ) : (
        <div
          className="user-image__placeholder"
          style={{ backgroundColor: `${color}` }}
          data-qa-id="user-image-placeholder"
        >
          <span className="name">{getPlaceholder}</span>
        </div>
      )}
    </div>
  );
};

UserImage.defaultProps = {
  ...UserImageDefaultProps,
};

UserImage.propTypes = {
  ...UserImagePropTypes,
};

export default UserImage;
